import { useLocation } from "react-router-dom";

export default function useURLQuery() {
    const location = useLocation<any>()
    return new URLSearchParams(location.search);
}